import { RootState } from 'core/store'
import { createSelector } from 'reselect'

function getNetwork(state: RootState) {
  return state.network
}

export const isCommunicating = createSelector(getNetwork, network => 0 < network)
